import { createRouter, createWebHistory } from 'vue-router'
import { config } from '../plugins/config'
import axios from '../plugins/axiosB'
import { collapseWebNavbars, focusMainContent } from '../utils/navbarCollapse'

import webRoutes from './web'
import appRoutes from './app'
import backendRoutes from './backend'
import authRoutes from './auth'

const routes = [...webRoutes, ...appRoutes, ...backendRoutes, ...authRoutes]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果網址含有錨點（hash），滾動至該錨點元素
    if (to.hash) {
      return { el: to.hash, top: 80 }
    }
    // 如果有保存的位置，滾動到保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否則滾動到頂部
    return { top: 0 }
  }
})

// 全域守衛檢查Token
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem(config.paramBackendToken)
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!token) {
      next({ name: 'backend-login' })
    } else {
      const resp = await axios.get('/B_Auth/check', null)
      if (resp == null) {
        localStorage.removeItem(config.paramBackendToken)
        next({ name: 'backend-login' })
      } else {
        next()
      }
    }
  } else {
    // 不需要驗證，直接訪問
    next()
  }
})

// 路由切換後，收合仍展開中的導覽列選單（避免漢堡選單維持展開遮蔽新頁面內容），
// 並將焦點移至新頁中央內容區。對應無障礙準則 CS1140101E。
router.afterEach((to, from) => {
  // 同頁 hash / query 變更不處理
  if (to.path === from.path) return

  collapseWebNavbars()

  // 僅 Web 前台版面（layout 路由 path 為 '/'）於切換後轉移焦點
  if (to.matched[0] && to.matched[0].path === '/') {
    focusMainContent()
  }
})

export default router
